import { render, staticRenderFns } from "./editProductEvaluation.vue?vue&type=template&id=489e9642&scoped=true"
import script from "./editProductEvaluation.vue?vue&type=script&lang=js"
export * from "./editProductEvaluation.vue?vue&type=script&lang=js"
import style0 from "./editProductEvaluation.vue?vue&type=style&index=0&id=489e9642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e9642",
  null
  
)

export default component.exports